/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthControllerUserInfo200Response
 */
export interface AuthControllerUserInfo200Response {
    /**
     * 
     * @type {string}
     * @memberof AuthControllerUserInfo200Response
     */
    email: string;
}

/**
 * Check if a given object implements the AuthControllerUserInfo200Response interface.
 */
export function instanceOfAuthControllerUserInfo200Response(value: object): value is AuthControllerUserInfo200Response {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function AuthControllerUserInfo200ResponseFromJSON(json: any): AuthControllerUserInfo200Response {
    return AuthControllerUserInfo200ResponseFromJSONTyped(json, false);
}

export function AuthControllerUserInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthControllerUserInfo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function AuthControllerUserInfo200ResponseToJSON(json: any): AuthControllerUserInfo200Response {
    return AuthControllerUserInfo200ResponseToJSONTyped(json, false);
}

export function AuthControllerUserInfo200ResponseToJSONTyped(value?: AuthControllerUserInfo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

